// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__EyWtY","emails":"CreateEditClinics_emails__27do4","emailTagLabel":"CreateEditClinics_emailTagLabel__1YWfe"};